import { zh_CN } from './zh_CN';
import { zh_TW } from './zh_TW';
import { en_US } from './en_US';
import { vi } from './vi';
import { km } from './km';
import { th } from './th';
import { lo } from './lo';

export const sharedComponentsI18n = {
  zh_CN,
  zh_TW,
  en_US,
  vi,
  km,
  th,
  lo
};
